import React from "react";
import "./onboardFormTextMd.scss";
const OnboardFormTextMd = ({ txt }) => {
  return <span className="onboard-form-text-md">{txt}</span>;
};

export default OnboardFormTextMd;
